module.exports = __webpack_public_path__ + "47656264610261b4699d124564c7f280.png";